import { type RefObject, type FC } from 'react';
import { BsCheckCircleFill } from 'react-icons/bs';

import cn from '@core/utils/classNames';

import styles from './SNHUCardDescription.module.css';

type Props = {
  valueProps?: { label?: string; text?: string }[];
  showDescription: boolean;
  descriptionRef: RefObject<HTMLDivElement>;
  header?: string;
};

const SNHUCardDescription: FC<Props> = ({ header = '', valueProps, showDescription, descriptionRef }) => (
  <>
    {/* description */}

    <div className={styles.cardDescriptionContainer}>
      <h4>{header}</h4>
      <div ref={descriptionRef} className={cn(styles.cardDescription, showDescription && styles.expand)}>
        <ul className={!showDescription ? styles.stretch : null}>
          {valueProps?.map(({ label, text = '' }) => (
            <li key={label}>
              <BsCheckCircleFill size={16} />
              <span>
                <h6>{label}</h6>
                <p dangerouslySetInnerHTML={{ __html: text }} />
              </span>
            </li>
          ))}
        </ul>

        {/* gradient overlay */}
        <div className={showDescription ? styles.hide : styles.gradient} />
      </div>
    </div>
  </>
);

export default SNHUCardDescription;
